import * as React from "react";
import { withAuthConsumer } from "../authcontext/AuthConsumer";
import { Navigate } from "react-router-dom";

const HomeRedirect = (props) => {
  const isAuthenticated = props.isAuthenticated;

  return !isAuthenticated ? (
    <Navigate to="/connexion" replace />
  ) : (
    <Navigate to="/tableau-de-bord" replace />
  );
};

export default withAuthConsumer(HomeRedirect);
